/* eslint-disable import/no-default-export */
import {SideCartController} from '../../components/SideCart/SideCartController';
import {controllerFactory} from '@wix/wixstores-client-storefront-sdk';

export default controllerFactory(SideCartController, {shouldSkipMultilingual: true});
